<div class="shares-number-container ">
  <div [class]="{ 'number': hasIssue }">
    {{ applyCurrency && value != null ? (value | currency: '$': 'code': '1.2-2') : (value ?? '-') }}
  </div>

  @if (hasIssue) {
    <div class="color-red line-height-0">
      <span class="hide-empty line-height-0">{{ alertPrefix }}</span>
      <span class="line-height-0">
        {{ applyCurrency ? (alertValue | currency: '$': 'code': '1.2-2') : alertValue }}
      </span>
    </div>
  }
</div>
